/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { USER_PROFILE } from "./test-data/user.profile";

const SERVICE_NAME = "UserProfileService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class UserProfileService {
    private static instance: UserProfileService;
    private constructor(props: any = {}) {}
    public static getInstance(props: any = {}): UserProfileService {
        if (!this.instance) {
            this.instance = new UserProfileService(props);
        }
        return this.instance;
    }

    async getUserProfileSummary(userId: string) {
        const _found = _.find(USER_PROFILE, {
            userId: userId,
        });
        return {
            ..._found,
        };
    }
}
